import { computed,nextTick, toRaw } from 'vue'


export function useFlatNodes(rootRef) {
    const flatNodes = computed(() => {
        const result  = []
        const visited = new Set()

        function flatten(node, level) {
            if (!node || visited.has(node)) return
            visited.add(node)
            result.push({ node, level })
            if (node.expanded && Array.isArray(node.children)) {
                node.children.forEach(child => flatten(child, level + 1))
            }
        }

        ;(rootRef.value.children || []).forEach(child => flatten(child, 0))          
        return result
    })
    return { flatNodes }
}
